import { useEffect, useState } from 'react';

/**
 * Drawer open state with Escape-to-close and body scroll lock.
 * Closes automatically when `closeKey` changes (e.g. route pathname).
 */
export function useSideDrawer(closeKey?: string) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [closeKey]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [open]);

  return {
    open,
    setOpen,
    openDrawer: () => setOpen(true),
    closeDrawer: () => setOpen(false),
    toggleDrawer: () => setOpen((prev) => !prev),
  };
}
